import { NgModule } from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {TeamStartPageComponent} from '@modules/team/pages/team-start-page/team-start-page.component';
import {TeamNewsComponent} from '@modules/team/pages/team-news/team-news.component';
import {TeamMatchesComponent} from '@modules/team/pages/team-matches/team-matches.component';
import {TeamMatchesWrapperComponent} from '@modules/team/pages/team-matches/team-matches-wrapper.component';
import {TeamTableComponent} from '@modules/team/pages/team-table/team-table.component';
import {TeamSquadComponent} from '@modules/team/pages/team-squad/team-squad.component';
import {TeamInfoSponsorsComponent} from '@team-modules/team-info/pages/sponsors/team-info-sponsors.component';
import {ClubTeamsComponent} from '@modules/team/pages/club-teams/club-teams.component';
import {NewsResolver} from '@modules/home/tabs/news/resolvers/news-resolver.service';
import {TeamRoutes} from '@app/routes/team.routes';
import {GameDetailRoutes} from '@app/routes/game-detail.routes';
import {TeamSquadPlayersComponent} from '@modules/team/pages/team-squad/team-squad-players/team-squad-players.component';
import {TeamSquadTrainersComponent} from '@modules/team/pages/team-squad/team-squad-trainers/team-squad-trainers.component';
import {NewsDetailComponent} from '@shared/modules/shared-news-detail/components/news-detail/news-detail.component';
import {TeamVideosComponent} from '@modules/team/pages/team-videos/team-videos.component';
import {TeamTransfersComponent} from '@modules/team/pages/team-transfers/team-transfers.component';
import {TeamHomeComponent} from '@modules/team/pages/team-home/team-home.component';
import {TeamLivestreamsComponent} from '@modules/team/pages/team-livestreams/team-livestreams.component';
import {TeamReplaysComponent} from '@modules/team/pages/team-replays/team-replays.component';
import { TeamAboGuard } from './guards/team-abo.guard';

export const routes: Routes = [
  { path: TeamRoutes.Abo.Index, canActivate: [ TeamAboGuard ] },
  { path: TeamRoutes.Abo.Subscribe, canActivate: [ TeamAboGuard ] },
  {
    path: '',
    component: TeamStartPageComponent,
    children: [
      { path: '', pathMatch: 'full', component: TeamHomeComponent},
      { path: TeamRoutes.news.root, component: TeamNewsComponent},
      { path: TeamRoutes.news.detail, component: NewsDetailComponent, resolve: {newsEntry: NewsResolver} },
      {
        path: GameDetailRoutes.root.default,
        loadChildren: () => import('@modules/game-detail/game-detail.module').then(m => m.GameDetailModule),
      },
      {
        path: TeamRoutes.games.root,
        component: TeamMatchesWrapperComponent,
        children: [
          { path: '', redirectTo: TeamRoutes.games.upcoming, pathMatch: 'full' },
          { path: TeamRoutes.games.upcoming, component: TeamMatchesComponent, data: {future: true, key: 'teamFutureGames' } },
          { path: TeamRoutes.games.past, component: TeamMatchesComponent, data: {future: false, key: 'teamPastGames' }},
        ]
      },
      {
        path: TeamRoutes.info.root,
        loadChildren: () => import('@team-modules/team-info/team-info.module').then(m => m.TeamInfoModule),
      },
      { path: TeamRoutes.table, component: TeamTableComponent },
      {
        path: TeamRoutes.squad.root,
        component: TeamSquadComponent,
        children: [
          { path: '', redirectTo: TeamRoutes.squad.players },
          { path: TeamRoutes.squad.players, component: TeamSquadPlayersComponent },
          { path: TeamRoutes.squad.trainers, component: TeamSquadTrainersComponent },
        ]
      },
      { path: TeamRoutes.sponsors, component: TeamInfoSponsorsComponent },
      { path: TeamRoutes.clubTeams, component: ClubTeamsComponent },
      { path: TeamRoutes.videos.root, component: TeamVideosComponent },
      { path: TeamRoutes.videos.live, component: TeamLivestreamsComponent },
      { path: TeamRoutes.videos.replay, component: TeamReplaysComponent },
      { path: TeamRoutes.transfers, component: TeamTransfersComponent },
      { path: '**', redirectTo: '/404' }
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TeamRouting { }
